import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { ProvideEnvironment } from '@rxap/environment';
import { HttpErrorInterceptor, ProvideErrorHandler } from 'angular-components/error-system';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import { CompanySelectInterceptor } from 'angular-http-interceptors/company-select-interceptor';
import { provideServiceWorker } from '@angular/service-worker';
import { KeycloakBearerInterceptor } from 'eurogard-keycloak';
import {
  AuthHttpInterceptor,
  CorsInterceptor,
  ProvideAuthWithInitializer,
} from 'eurogard-authentication';
import { ProvideI18nMatIntl } from 'angular-components/localize/provide';
import { ProvideErrorInterceptorOptions } from 'angular-application-providers/provide-error-interceptor-options';
import { MarkdownModule } from 'ngx-markdown';
import { LanguageInterceptor } from 'angular-services/user-area/language-interceptor';
import { ProvideServiceWorkerUpdater, withDialogUpdater, withLogUpdater } from '@rxap/service-worker';
import { ProvidePubSub } from '@rxap/ngx-pub-sub';
import { ProvideDate } from 'angular-application-providers/provide-date';
import { ProvideSetLanguageHook } from 'angular-application-providers/provide-set-language-hook';
import { ProvideIconAssetPath } from '@rxap/icon';
import { provideExternalAppsFilter } from 'angular-application-providers/provide-external-apps-filter';
import { provideTheme } from 'angular-services/theme/provide';
import { provideExternalApps } from 'angular-services/layout/provide';
import { HIGHLIGHT_OPTIONS, provideHighlightOptions } from 'ngx-highlightjs';
import { Angulartics2Module } from 'angulartics2';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BsDropdownModule.forRoot(), MarkdownModule.forRoot(), Angulartics2Module.forRoot({ pageTracking: { clearQueryParams: true } })),
    provideHighlightOptions({
      fullLibraryLoader: () => import('highlight.js'),
      lineNumbersLoader: () => import('ngx-highlightjs/line-numbers'),
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.serviceWorker,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    // required to be imported so that the http client is available in the application for the status check method
    provideHttpClient(
      withInterceptors([
        HttpErrorInterceptor,
        CompanySelectInterceptor,
        AuthHttpInterceptor,
        CorsInterceptor,
        KeycloakBearerInterceptor,
        LanguageInterceptor,
      ]),
    ),
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    provideAnimations(),
    ProvideErrorHandler(),
    ProvideAuthWithInitializer(),
    ProvideI18nMatIntl(),
    ProvideIconAssetPath(),
    ProvideErrorInterceptorOptions(),
    ProvideEnvironment(environment),
    ProvideServiceWorkerUpdater(withLogUpdater(), withDialogUpdater()),
    ProvidePubSub(),
    ProvideDate(),
    ProvideSetLanguageHook(),
    provideExternalApps(),
    provideExternalAppsFilter(),
    provideTheme(),
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        coreLibraryLoader: () => import('highlight.js/lib/core'),
        languages: {
          xml: () => import('highlight.js/lib/languages/xml'),
          typescript: () => import('highlight.js/lib/languages/typescript'),
          scss: () => import('highlight.js/lib/languages/scss'),
        }
      }
    }
  ],
};
